import React, { useEffect, useState } from "react";
import ArrowBackIos from "../../assets/images/misc/arrow_back_ios_new.png";
import Link from "componentsTemplate/Link";
import { FaArrowAltCircleRight } from "react-icons/fa";
import { getFaq } from "services/FaqService";
import { toast } from "react-toastify";
import ListQuestionsFaq from "components/faq/ListQuestionsFaq";


const Faq: React.FC = () => {

  const [loading, setLoading] = useState(true);
  const [faqs, setFaqs] = useState<any[]>([]);
  const [categorySelected, setCategorySelected] = useState<any>(null);

  useEffect(() => {
    setLoading(true);
    fetch();
  }, []);

  const fetch = async () => {
    try {
      const data = await getFaq();
      setFaqs(data);
    } catch (error) {
      toast.error("Erro ao carregar os dados");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <section>
        <div
          className="flex bg-bottom bg-cover h-[280px]"
        >
          <div className="bg-[#262626] flex h-full w-full items-end justify-start">
            <div className="flex flex-row my-4 ml-8 md:ml-40 mb-10">
              <div className="columns-1 w-[15px] h-[170px] bg-[#A27F59] bg-cover"></div>
              <div className="columns-1 flex flex-col h-[170px] justify-center">
                <div className="text-left text-lg lg:text-xl xl:text-3xl text-white ml-10">
                  Rede de Suporte Radar
                </div>
                <div className="text-left font-bold text-2xl lg:text-4xl xl:text-6xl text-white flex-wrap ml-10">
                  FAQ
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="flex items-center flex-col lg:flex-row lg:gap-x-10 xl:gap-x-16 justify-between py-[54px] relative gap-y-10 px-8 md:px-16 xl:px-40 2xl:px-72 sm:w-auto backdrop-sepia backdrop-brightness-50 backdrop-blur-sm">
          <div className="w-full" style={{ minHeight: '300px' }}>
            <div className="flex justify-between">
              <p className="[font-family:'Poppins-ExtraBold',Helvetica] font-extrabold text-transparent text-4xl tracking-[0.80px] leading-[normal]">
                <span className="text-neutral-800 dark:text-white">Dúvidas </span>
                <span className="text-[#695339]">Frequentes</span>
              </p>

              {
                categorySelected && (
                  <div 
                    onClick={() => setCategorySelected(null)}
                    className="w-fit rounded-full bg-primary-900 text-white px-4 py-3 hover:bg-primary-600 cursor-pointer h-12"
                  >
                    Voltar
                  </div>
                )
              }

            </div>
            
            <div className="w-full">
              {
                categorySelected ? (
                  <div className="grid grid-cols-1 mt-8 gap-8">
                    <ListQuestionsFaq
                      faq={faqs.find((faq : any) => faq.id === categorySelected)}
                    />
                  </div>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 mt-8 gap-8">
                    {
                      faqs.map((faq : any, index : any) => (
                        <div onClick={() => setCategorySelected(faq.id)} key={index} className="flex bg-primary-50 rounded-lg shadow-xl px-10 py-5 items-center justify-between hover:text-[#a27f59] text-[#866d4f] cursor-pointer">
                          <p className="text-xl [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold leading-[normal]">
                            {faq.name}
                          </p>
                          <div>
                            <FaArrowAltCircleRight size={30} />
                          </div>
                        </div>
                      ))
                    }
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </section>

      <section
        className="bg-cover bg-bottom w-full"
      >
        <div className="px-8 md:px-16 xl:px-40 2xl:px-72 flex flex-col py-24 justify-between gap-y-20 items-center bg-primary-50 backdrop-blur-sm backdrop-brightness-50 w-full">
          <div className="flex flex-col justify-center items-center text-center gap-y-3">
            <div>
              <span className="text-[#262626] text-[40px] [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold leading-[normal]">
                Quero ser uma
              </span>
              <span className="text-[#695339] ml-4 text-[40px] [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold leading-[normal]">
                Radar
              </span>
            </div>
            <span className="text-[#a27f59] text-[16px] [font-family:'Poppins-ExtraBold',Helvetica] leading-[normal]">
              Faça parte da maior e mais influente rede de conexões de mulheres
              do Brasil
            </span>
          </div>
          <div className="flex justify-between items-center">
            <img
              className="w-[85px] h-[85px] mt-[-10rem] mr-[-2rem]"
              alt="Arrow back ios new"
              src={ArrowBackIos}
            />
            <div className="flex w-[45vw]">
              <span className="text-[#a27f59] sm:text-base lg:text-lg xl:text-xl 2xl:text-2xl text-center [font-family:'Poppins-ExtraBold',Helvetica] font-extrabold">
                <b style={{ fontSize: "25px" }}>
                  "Queremos empoderar e impactar o maior número de mulheres."
                </b>
              </span>
            </div>
            <img
              className="w-[85px] h-[85px] rotate-180 mb-[-10rem] ml-[-2rem]"
              alt="Arrow back ios new"
              src={ArrowBackIos}
            />
          </div>

          <Link
            href={"/cadastro"}
            className="w-fit rounded-full bg-primary-900 text-white px-4 py-3 hover:bg-primary-600"
          >
            Quero entrar para o Radar
          </Link>
        </div>
      </section>
    </div>
  );
};
export default Faq;
